import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { useFlag } from '@modernloop/shared/feature-flag';
import { MaximizeIcon, ModernLoopLogoIcon } from '@modernloop/shared/icons';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';

import useHistory from 'src/hooks/useHistory';

import AIAssistant from 'src/views-new/AIAssistant';
import { AGENT_SURFACE, useAgentChatSession } from 'src/views-new/AIAssistant/AgentChatSessionProvider';
import { getAgentRouteForThread } from 'src/views-new/AIAssistant/agent/agentRoutes';

import SidePanelContainer from '../common/SidePanelContainer';
import { SidePanelManager } from '../common/SidePanelManager';

/** Side-panel presentation of the global Agent, including a route expansion control. */
const AIAssistantSidepanel = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const globalAgentEnabled = useFlag('AI_GLOBAL_AGENT');
  const { hasStartedConversation, openThread, threadId } = useAgentChatSession();

  if (!globalAgentEnabled) {
    return null;
  }

  const handleExpand = () => {
    // The full page consumes the same dashboard session; close this shell before navigation only.
    openThread(AGENT_SURFACE.FULL_PAGE);
    SidePanelManager.closeSidePanel();
    history.push(getAgentRouteForThread(threadId, hasStartedConversation));
  };

  return (
    <SidePanelContainer
      header={
        <Stack direction="row" alignItems="center" gap={1}>
          <ModernLoopLogoIcon sx={{ height: '40px', width: '40px' }} />
          <Typography variant="subtitle1">{t('hiring-dashboard-nav:nav.sidePanel.aiAssistantHeader')}</Typography>
          <Tooltip title={t('hiring-dashboard-ai-assistant:agent.expandToPage')}>
            <IconButton
              aria-label={t('hiring-dashboard-ai-assistant:agent.expandToPage')}
              data-testid="agent-expand-to-page"
              onClick={handleExpand}
              size="small"
            >
              <MaximizeIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      }
      betaFlag={{ flag: 'AI_ENABLED', tooltip: t('hiring-dashboard-nav:nav.sidePanel.aiAssistantHeader') }}
    >
      <AIAssistant />
    </SidePanelContainer>
  );
};

export default AIAssistantSidepanel;
